<div class="app-toastbar" *ngIf="isShow===true">
  <div>
    <i class="pi pi-chevron-circle-down"></i>
    Successfully created
  </div>
  <i class="pi pi-times" (click)="onClose()"></i>
</div>
